import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '~/app/pricing';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

/**
 * Arabic pricing page.
 *
 * Reuses `PricingPage` unchanged: the component resolves its copy and fee table
 * from `useContent()`, which reads the language off the URL, so nothing about the
 * page is language-specific here beyond its head metadata.
 */
export const Route = createFileRoute('/ar/pricing')({
  head: () =>
    pageHeadMeta({
      title: 'الأسعار — nsave',
      description:
        'اعرف رسوم nsave بالتفصيل لحسابات الأفراد والشركات: فتح الحساب، والاستقبال، والتحويلات، والكروت، وتحويل العملات، والمكافآت.',
      path: '/ar/pricing',
      stylesheets: [pricingStylesHref],
    }),
  component: PricingPage,
});
